import React, { useEffect, useRef, useState } from "react";

import { DatePicker } from "@mantine/dates";


import { SlCalender } from "react-icons/sl";
import { PiCaretDown } from "react-icons/pi";
import moment from "moment";

const NewDate = ({
  value,
  onChange,
  error = null,
  required = true,
 
  inputRequired = false,
  inputClassName = "",
  minDate,
  maxDate,
  disabled = false,
}) => {
  const [dateOfBirth, setDateOfBirth] = useState("");

  useEffect(() => {
    const formatDOB = (val) => {
      const parts = val?.split?.("-");
      const [month, day, year] = parts || [];
      console.log(month, day, year);
      return day && month && year ? `${month}-${day}-${year}` : val;
    };

    setDateOfBirth(value);
  }, [value]);

 

  return (
   
     
   
        <DateInput
          
          value={dateOfBirth}
          required={required}
          onChange={onChange}
          inputClassName={inputClassName}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
        />
     
      
   
  );
};

export default NewDate;

function DateInput({
 
  value,

  onChange,
  
  minDate,
  maxDate,
  disabled,
}) {
  const [isOpen, setIsOpen] = useState();
  const dateRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDobChange = (e) => {
    let cleaned = e.target.value.replace(/\D/g, "");
    cleaned = cleaned.slice(0, 8);

    if (cleaned.length > 4) {
      cleaned = cleaned.replace(/^(\d{2})(\d{2})(\d{0,4})/, "$1-$2-$3");
    } else if (cleaned.length > 2) {
      cleaned = cleaned.replace(/^(\d{2})(\d{0,2})/, "$1-$2");
    }

    const parts = cleaned.split("-");
    if (parts.length > 0) {
      let mm = parts[0];
      if (mm && parseInt(mm, 10) > 12) {
        mm = "12";
        cleaned =
          "12" +
          (parts[1] ? "-" + parts[1] : "") +
          (parts[2] ? "-" + parts[2] : "");
      }
    }
    if (parts.length > 2) {
      let yyyy = parts[2];
      const currentYear = new Date().getFullYear();
      if (yyyy && parseInt(yyyy, 10) > currentYear) {
        yyyy = String(currentYear);
        cleaned = parts[0] + "-" + parts[1] + "-" + yyyy;
      } else if (yyyy && String(yyyy).length === 4 && parseInt(yyyy, 10) < 1920) {
        cleaned = parts[0] + "-" + parts[1] + "-" + 1920;
      }
    }
    if (parts.length > 1) {
      let dd = parts[1];
      if (dd && parseInt(dd, 10) > 31) {
        dd = "31";
        cleaned = parts[0] + "-31" + (parts[2] ? "-" + parts[2] : "");
      }
    }
    onChange(cleaned);
  };

  return (
      <div className="enrollment-date-input" style={{position:"relative"}}>
           <SlCalender size={'18px'}  />
      <input
        type="tel"
        placeholder={"MM-DD-YYYY"}
        value={value}
        style={{background:'transparent'}}
        className="travel-date"
        onChange={handleDobChange}
       
        
          />

          <PiCaretDown size={'18px'} onClick={() => {
          if (!disabled) {
            setIsOpen(true);
          }
        }}/>
         
     
      {isOpen && (
        <div
          ref={dateRef}
          className={`travel-date-wrapper`}
          style={{
            padding: "20px",
          }}
        >
          <DatePicker
            // defaultValue={new Date()}
            size="sm"
            value={value}
            onChange={(date) => {
              const formattedDate = moment(date).format("MM-DD-YYYY");
                           onChange(formattedDate);
              setIsOpen(false);
            }}
            minDate={minDate}
            maxDate={maxDate}
            defaultDate={value ? new Date(value) : new Date()} 
          />
        </div>
      )}
    </div>
  );
}
